import { opdHtml } from "../pages/OPD/opdPrintHtml";
import { billInfo } from "../pages/Patient/billHtml";

export const printFunc = (printvalue, type) => {
    const mywindow = window.open("", "_blank", "");
    mywindow.document.open();
    const css = "@page {size: Auto;margin: 2.5cm !important;}",
        style = document.createElement("style");
    style.type = "text/css";
    style.media = "print";
    if (style.styleSheet) {
        style.styleSheet.cssText = css;
    } else {
        style.appendChild(document.createTextNode(css));
    }
    type === "opd" ? mywindow.document.write(opdHtml(printvalue && printvalue?.result[0])) :
    mywindow.document.write(billInfo(printvalue && printvalue[0]));
    mywindow.document.getElementsByTagName("head")[0].append(style);
    mywindow.document.close(); // necessary for IE >= 10
    mywindow.focus(); // necessary for IE >= 10*/
    setTimeout(() => {
        mywindow.print();
        mywindow.close();
    }, 100);
    return mywindow;
}
export function numberToWords(number) {
    const units = ['Zero', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
    const teens = ['Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
    const tens = ['', 'Ten', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];
    const thousands = ['', 'Thousand', 'Million', 'Billion'];
  
    function convertThreeDigits(num) {
      let words = '';
  
      if (num >= 100) {
        words += units[Math.floor(num / 100)] + ' Hundred ';
        num %= 100;
      }
  
      if (num >= 11 && num <= 19) {
        words += teens[num - 11] + ' ';
      } else {
        words += tens[Math.floor(num / 10)] + ' ';
        words += units[num % 10] + ' ';
      }
  
      return words;
    }
  
    if (number === 0) {
      return 'Zero';
    }
  
    let result = '';
    let chunkIndex = 0;
  
    while (number > 0) {
      const chunk = number % 1000;
      if (chunk !== 0) {
        result = convertThreeDigits(chunk) + thousands[chunkIndex] + ' ' + result;
      }
  
      number = Math.floor(number / 1000);
      chunkIndex++;
    }
  
    return result.trim();
  }

  export function numberWithCommas(x) {
    return x.toString().split('.')[0].length > 3 ? x.toString().substring(0,x.toString().split('.')[0].length-3).replace(/\B(?=(\d{2})+(?!\d))/g, ",") + "," + x.toString().substring(x.toString().split('.')[0].length-3): x.toString();
}